<template>
  <el-dialog title="修改头像" width="350px" :visible.sync="formVisible" :close-on-click-modal="false">
    <el-col :span="24" style="margin-bottom: 20px;">
      <!-- <el-form :model="formData" label-width="80px" :rules="formRules" ref="formd"> -->
      <!-- <el-form-item label="头像" prop="name"> -->
      <div class="cont">
        <div><img :src="avatimgs" class="img"></div>
        <div class="sels"><input type="file" accept="image/jpeg,image/jpg,image/png"
            @change="changeImg($event)"></div>

        <!-- </el-form-item> -->
        <!-- <div>
                  <el-tag type="warning">提现需要收取10%手续费</el-tag>
              </div> -->
        <!-- </el-form> -->
      </div>
    </el-col>
    <!--工具条-->
    <div slot="footer" class="dialog-footer">
      <el-button @click.native="formVisible = false">取消</el-button>
      <el-button type="primary" @click.native="formSubmit" :loading="formLoading">确认</el-button>
    </div>
  </el-dialog>
</template>


<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      formVisible: false,
      formLoading: false,
      formData: {},
      avatseled: false,
      avatimgs: '',
    }
  },
  computed: {
    // 使用对象展开运算符将 getters 混入 computed 对象中
    ...mapGetters([
      'getUserInfo'
    ])
  },
  mounted () {
    // this.getLastImg();
  },
  methods: {
    show () {
      this.formVisible = true;
      this.avatseled = false;
      this.avatimgs = this.getUserInfo.avat;
    },
    /*handleSelect:function(id){
                    this.tmpltCont='';
                    if(id==''){
                        return
                    }
                    let it=this.tmplatdatas[id];
                    if(it==null){
                        return
                    }
                    //console.log("123",this.tmplatdatas[id]);
                    this.tmpltCont=it.Content;
                    this.tmpltmapls=[];
                    SmsTmpltKeys(id).then(res=>{
                        for(let i in res.data){
                            this.tmpltmapls.push({
                                key:res.data[i],value:''
                            });
                        }
                    });
                },*/
    formSubmit () {
      if (!this.avatseled) {
        this.$message({
          message: '未选择新头像',
          type: 'error'
        });
        return;
      }
      this.formLoading = true;
      this.$post('/user/avat', { imgs: this.avatimgs }).then(res => {
        console.log(res);
        this.$message('操作成功');
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }).catch(err => {
        this.formLoading = false;
        //this.formVisible = false;
        this.$message({
          message: err.response ? err.response.data || '服务器错误' : '网络错误',
          type: 'error'
        });
      });
    },
    changeImg (e) {
      let file = e.target.files[0]
      if (file.size > 1 * 1024 * 1024) {
        this.$message({
          message: '【' + (file.name.length > 20 ? file.name.substring(0, 20) + '...' : file.name) + '】 超过1M',
          type: 'error'
        });
        return;
      }
      let that = this
      let reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = function (e) {
        that.avatseled = true;
        that.avatimgs = this.result;
      }
    }
  }
};
</script>

<style scoped>
.tmpdesc {
  margin-left: 10px;
  color: #d0d0d0;
}

.cont {
  text-align: center;
}

.sels {
  padding: 5px;
  border: 1px solid #aaa;
}

.img {
  width: 150px;
  height: 150px;
}
</style>




// WEBPACK FOOTER //
// avatEdit.vue?1d7b45a8